(function() {
// Multi-language translation dictionaries
const translations = {
    'en-GB': {
        orderNumber: 'Order',
        placedOn: 'Placed on',
        paymentStatus: 'Payment Status',
        carrier: 'Carrier',
        shippingTo: 'Shipping To',
        contactEmail: 'Contact Email',
        orderItems: 'Order Items',
        total: 'Total',
        trackPackage: 'Track Package',
        shipped: 'Shipped',
        processing: 'Processing',
        pending: 'Pending Payment',
        paid: 'Paid',
        unpaid: 'Unpaid',
        refunded: 'Refunded',
        orderNotFound: 'Commande introuvable. Veuillez vérifier votre numéro de commande et votre e-mail.',
        connectionError: 'Impossible de se connecter au serveur. Veuillez réessayer plus tard.',
        searching: 'Searching...',
        findMyOrder: 'Find My Order',
        qty: 'Qty',
        trackingAvailableSoon: 'Tracking will be available soon',
        untrackedDelivery: 'Your order has been dispatched and is on its way to you.',
        downloadInvoice: 'Download Invoice',
        invoice: 'Invoice',
        date: 'Date',
        orderDetails: 'Order Details',
        shippingDetails: 'Shipping Details',
        item: 'Item',
        quantity: 'Quantity',
        price: 'Price',
        status: 'Status',
        thankYou: 'Thank you for choosing Braceletsmartwatch.fr. Your support means a lot to us.',
        popupBlocked: 'Please allow popups to download the invoice'
    },
    'nl-NL': {
        orderNumber: 'Bestelling',
        placedOn: 'Geplaatst op',
        paymentStatus: 'Betaalstatus',
        carrier: 'Vervoerder',
        shippingTo: 'Verzenden naar',
        contactEmail: 'Contact E-mail',
        orderItems: 'Artikelen',
        total: 'Totaal',
        trackPackage: 'Pakket volgen',
        shipped: 'Verzonden',
        processing: 'In behandeling',
        pending: 'Betaling in behandeling',
        paid: 'Betaald',
        unpaid: 'Niet betaald',
        refunded: 'Terugbetaald',
        orderNotFound: 'Bestelling niet gevonden. Controleer uw bestelnummer en e-mailadres.',
        connectionError: 'Kan geen verbinding maken met de server. Probeer het later opnieuw.',
        searching: 'Zoeken...',
        findMyOrder: 'Mijn bestelling zoeken',
        qty: 'Aantal',
        trackingAvailableSoon: 'Tracking binnenkort beschikbaar',
        untrackedDelivery: 'Uw bestelling is verzonden en onderweg naar u.',
        downloadInvoice: 'Factuur downloaden',
        invoice: 'Factuur',
        date: 'Datum',
        orderDetails: 'Bestelgegevens',
        shippingDetails: 'Verzendgegevens',
        item: 'Artikel',
        quantity: 'Aantal',
        price: 'Prijs',
        status: 'Status',
        thankYou: 'Bedankt voor uw bestelling!',
        popupBlocked: 'Sta pop-ups toe om de factuur te downloaden'
    },
    'de-DE': {
        orderNumber: 'Bestellung',
        placedOn: 'Aufgegeben am',
        paymentStatus: 'Zahlungsstatus',
        carrier: 'Versanddienstleister',
        shippingTo: 'Versand nach',
        contactEmail: 'Kontakt E-Mail',
        orderItems: 'Bestellte Artikel',
        total: 'Gesamt',
        trackPackage: 'Paket verfolgen',
        shipped: 'Versandt',
        processing: 'In Bearbeitung',
        pending: 'Zahlung ausstehend',
        paid: 'Bezahlt',
        unpaid: 'Unbezahlt',
        refunded: 'Erstattet',
        orderNotFound: 'Bestellung nicht gefunden. Bitte überprüfen Sie Ihre Bestellnummer und E-Mail-Adresse.',
        connectionError: 'Verbindung zum Server nicht möglich. Bitte versuchen Sie es später erneut.',
        searching: 'Suchen...',
        findMyOrder: 'Meine Bestellung finden',
        qty: 'Menge',
        trackingAvailableSoon: 'Sendungsverfolgung bald verfügbar',
        untrackedDelivery: 'Ihre Bestellung wurde versandt und ist unterwegs zu Ihnen.',
        downloadInvoice: 'Rechnung herunterladen',
        invoice: 'Rechnung',
        date: 'Datum',
        orderDetails: 'Bestelldetails',
        shippingDetails: 'Versanddetails',
        item: 'Artikel',
        quantity: 'Menge',
        price: 'Preis',
        status: 'Status',
        thankYou: 'Vielen Dank für Ihren Einkauf!',
        popupBlocked: 'Bitte erlauben Sie Pop-ups, um die Rechnung herunterzuladen'
    },
    'es-ES': {
        orderNumber: 'Pedido',
        placedOn: 'Realizado el',
        paymentStatus: 'Estado del pago',
        carrier: 'Transportista',
        shippingTo: 'Envío a',
        contactEmail: 'Correo de contacto',
        orderItems: 'Artículos del pedido',
        total: 'Total',
        trackPackage: 'Rastrear paquete',
        shipped: 'Enviado',
        processing: 'Procesando',
        pending: 'Pago pendiente',
        paid: 'Pagado',
        unpaid: 'No pagado',
        refunded: 'Reembolsado',
        orderNotFound: 'Pedido no encontrado. Por favor, verifique su número de pedido y correo electrónico.',
        connectionError: 'No se puede conectar al servidor. Por favor, inténtelo más tarde.',
        searching: 'Buscando...',
        findMyOrder: 'Buscar mi pedido',
        qty: 'Cant',
        trackingAvailableSoon: 'Seguimiento disponible pronto',
        untrackedDelivery: 'Su pedido ha sido enviado y está en camino.',
        downloadInvoice: 'Descargar factura',
        invoice: 'Factura',
        date: 'Fecha',
        orderDetails: 'Detalles del pedido',
        shippingDetails: 'Detalles de envío',
        item: 'Artículo',
        quantity: 'Cantidad',
        price: 'Precio',
        status: 'Estado',
        thankYou: '¡Gracias por su compra!',
        popupBlocked: 'Por favor, permita ventanas emergentes para descargar la factura'
    },
    'fr-FR': {
        orderNumber: 'Commande',
        placedOn: 'Passée le',
        paymentStatus: 'Statut du paiement',
        carrier: 'Transporteur',
        shippingTo: 'Expédition vers',
        contactEmail: 'E-mail de contact',
        orderItems: 'Articles commandés',
        total: 'Total',
        trackPackage: 'Suivre le colis',
        shipped: 'Expédié',
        processing: 'En cours',
        pending: 'Paiement en attente',
        paid: 'Payé',
        unpaid: 'Non payé',
        refunded: 'Remboursé',
        orderNotFound: 'Commande introuvable. Veuillez vérifier votre numéro de commande et votre adresse e-mail.',
        connectionError: 'Impossible de se connecter au serveur. Veuillez réessayer plus tard.',
        searching: 'Recherche...',
        findMyOrder: 'Trouver ma commande',
        qty: 'Qté',
        trackingAvailableSoon: 'Suivi disponible bientôt',
        untrackedDelivery: 'Votre commande a été expédiée et est en route.',
        downloadInvoice: 'Télécharger la facture',
        invoice: 'Facture',
        date: 'Date',
        orderDetails: 'Détails de la commande',
        shippingDetails: 'Détails d\'expédition',
        item: 'Article',
        quantity: 'Quantité',
        price: 'Prix',
        status: 'Statut',
        thankYou: 'Merci pour votre achat !',
        popupBlocked: 'Veuillez autoriser les pop-ups pour télécharger la facture',
        company: 'Entreprise',
        subtotal: 'Sous-total',
        shipping: 'Frais de livraison',
        tax: 'TVA',
        discount: 'Remise',
        grandTotal: 'Total à payer'
    }
};

// Carrier tracking URL templates
const carrierRegistry = {
    'PostNL': {
        countries: ['NL', 'Netherlands'],
        urlTemplate: (trackingCode, postcode) => {
            if (postcode) {
                return `https://jouw.postnl.nl/track-and-trace/${trackingCode}-NL-${postcode}`;
            }
            return `https://jouw.postnl.nl/track-and-trace/${trackingCode}`;
        },
        requiresPostcode: true
    },
    'Landmark Global': {
        countries: ['BE', 'Belgium'],
        urlTemplate: (trackingCode) => `https://track.landmarkglobal.com/?search=${trackingCode}`,
        requiresPostcode: false
    },
    'Deutsche Post': {
        countries: ['DE', 'Germany'],
        urlTemplate: (trackingCode) => `https://www.deutschepost.de/de/s/sendungsverfolgung/verfolgen.html?piececode=${trackingCode}&lang=en&cid=brief`,
        requiresPostcode: false
    },
    'Sending ES': {
        countries: ['ES', 'Spain'],
        urlTemplate: (trackingCode) => `https://parcelsapp.com/es/tracking/${trackingCode}`,
        requiresPostcode: false
    },
    'Correos': {
        countries: ['ES', 'Spain'],
        urlTemplate: (trackingCode) => `https://parcelsapp.com/es/tracking/${trackingCode}`,
        requiresPostcode: false
    },
    'La Poste': {
        countries: ['FR', 'France'],
        urlTemplate: (trackingCode) => `https://www.laposte.fr/outils/suivre-vos-envois?code=${trackingCode}`,
        requiresPostcode: false
    },
    'Royal Mail': {
        countries: ['GB', 'UK', 'United Kingdom', 'IE', 'Ireland'],
        urlTemplate: (trackingCode) => `https://www.royalmail.com/track-your-item#/tracking-results/${trackingCode}`,
        requiresPostcode: false
    }
};

// Country to locale mapping
const countryToLocale = {
    'United Kingdom': 'en-GB',
    'GB': 'en-GB',
    'UK': 'en-GB',
    'Ireland': 'en-GB',
    'IE': 'en-GB',
    'Netherlands': 'nl-NL',
    'NL': 'nl-NL',
    'Belgium': 'nl-NL', // Default to Dutch for Belgium
    'BE': 'nl-NL',
    'Germany': 'de-DE',
    'DE': 'de-DE',
    'Spain': 'es-ES',
    'ES': 'es-ES',
    'France': 'fr-FR',
    'FR': 'fr-FR'
};

// Currency symbols
const currencySymbols = {
    'GBP': '£',
    'EUR': '€',
    'USD': '$'
};

// API endpoint configuration
const API_ENDPOINT = 'https://actium.automagically.nl/webhook/track-order';

// Function to translate English date format to French
function translateDateToFrench(dateString) {
    if (!dateString) return dateString;

    const englishMonths = {
        'January': 'janvier', 'February': 'février', 'March': 'mars',
        'April': 'avril', 'May': 'mai', 'June': 'juin',
        'July': 'juillet', 'August': 'août', 'September': 'septembre',
        'October': 'octobre', 'November': 'novembre', 'December': 'décembre'
    };

    const englishDays = {
        'Monday': 'lundi', 'Tuesday': 'mardi', 'Wednesday': 'mercredi',
        'Thursday': 'jeudi', 'Friday': 'vendredi', 'Saturday': 'samedi', 'Sunday': 'dimanche'
    };

    let translated = dateString;
    for (const [eng, fr] of Object.entries(englishMonths)) {
        translated = translated.replace(new RegExp(eng, 'gi'), fr);
    }
    for (const [eng, fr] of Object.entries(englishDays)) {
        translated = translated.replace(new RegExp(eng, 'gi'), fr);
    }
    return translated;
}

document.addEventListener('DOMContentLoaded', function() {
    // Prevent native browser hash jumping on load which causes the page to scroll down
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }

    // Safety check - only run on pages with customer service portal
    if (!document.querySelector('.cs-section')) {
        return;
    }

    const navItems = document.querySelectorAll('.cs-nav-item');
    const sections = document.querySelectorAll('.cs-section');
    const faqItems = document.querySelectorAll('.faq-item');
    const contactForm = document.getElementById('contactForm');
    let pendingTransition = null;

    function setActiveNav(sectionId) {
        const currentNavItems = document.querySelectorAll('.cs-nav-item');
        const currentMobileItems = document.querySelectorAll('.cs-mobile-menu-item');

        currentNavItems.forEach(item => {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) {
                item.classList.add('active');
            }
        });

        currentMobileItems.forEach(item => {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) {
                item.classList.add('active');
            }
        });
    }

    function showSection(sectionId) {
        const targetSection = document.getElementById(sectionId);
        if (!targetSection) return;

        if (targetSection.classList.contains('page-active')) {
            return;
        }

        setActiveNav(sectionId);

        const currentSections = document.querySelectorAll('.cs-section');

        currentSections.forEach(section => {
            if (section.id !== sectionId) {
                section.classList.remove('page-active');
                section.classList.add('page-hidden');
            }
        });

        targetSection.classList.remove('page-hidden');
        targetSection.classList.add('page-active');

        // Instant scroll to top (with slight delay to override any native browser behavior)
        window.scrollTo(0, 0);
        setTimeout(() => window.scrollTo(0, 0), 10);
    }

    window.showSection = showSection;

    document.addEventListener('click', function(e) {
        if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;
        const navItem = e.target.closest('.cs-nav-item');
        if (navItem && navItem.dataset.section) {
            e.preventDefault();
            const sectionId = navItem.dataset.section;

            if (document.getElementById(sectionId)) {
                showSection(sectionId);

                const url = new URL(window.location);
                url.hash = sectionId;
                window.history.pushState({}, '', url);
            }
        }
    });

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');

        if (question) {
            question.addEventListener('click', function(e) {
                e.preventDefault();
                const isActive = item.classList.contains('active');

                // Record clicked item position before any layout changes
                const clickedRect = item.getBoundingClientRect();
                const clickedTopBefore = clickedRect.top;

                // Instantly collapse other FAQs (no transition) to prevent scroll jump
                faqItems.forEach(faq => {
                    if (faq !== item && faq.classList.contains('active')) {
                        const answer = faq.querySelector('.faq-answer');
                        if (answer) {
                            answer.style.transition = 'none';
                            answer.style.maxHeight = '0';
                            answer.style.padding = '0 1.5rem';
                        }
                        faq.classList.remove('active');
                        // Restore transition after layout settles
                        requestAnimationFrame(() => {
                            if (answer) answer.style.transition = '';
                            if (answer) answer.style.maxHeight = '';
                            if (answer) answer.style.padding = '';
                        });
                    }
                });

                if (!isActive) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }

                // Correct scroll position to keep clicked item in place
                requestAnimationFrame(() => {
                    const newRect = item.getBoundingClientRect();
                    const drift = newRect.top - clickedTopBefore;
                    if (Math.abs(drift) > 10) {
                        window.scrollBy(0, drift);
                    }
                });
            });
        }
    });

    const subjectDropdown = document.getElementById('subject');
    const customSubjectGroup = document.getElementById('customSubjectGroup');
    const customSubjectInput = document.getElementById('customSubject');

    function updateCustomSubjectVisibility() {
        if (subjectDropdown && customSubjectGroup && customSubjectInput) {
            if (subjectDropdown.value === 'Autre') {
                customSubjectGroup.style.display = 'block';
                customSubjectInput.setAttribute('required', 'required');
            } else {
                customSubjectGroup.style.display = 'none';
                customSubjectInput.removeAttribute('required');
                customSubjectInput.value = '';
            }
        }
    }

    if (subjectDropdown && customSubjectGroup && customSubjectInput) {
        updateCustomSubjectVisibility();
        subjectDropdown.addEventListener('change', updateCustomSubjectVisibility);
    }

    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            if (!contactForm.checkValidity()) {
                contactForm.reportValidity();
                return;
            }

            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const order = document.getElementById('order').value;
            const subjectDropdown = document.getElementById('subject').value;
            const customSubject = document.getElementById('customSubject').value;
            const message = document.getElementById('message').value;

            const subject = subjectDropdown === 'Autre' && customSubject ? customSubject : subjectDropdown;

            const emailSubject = `Service Client: ${subject}`;
            const emailBody = `Nom: ${name}
E-mail: ${email}
Numéro de Commande: ${order}
Sujet: ${subject}

Message:
${message}

---
Ce message a été envoyé depuis le portail service client Braceletsmartwatch.fr.`;

            const mailtoLink = `mailto:service@braceletsmartwatch.fr?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

            const submitBtn = contactForm.querySelector('.cs-submit-btn');
            const originalText = submitBtn.textContent;
            submitBtn.textContent = 'Ouverture de l\'e-mail...';

            window.location.href = mailtoLink;

            setTimeout(() => {
                contactForm.reset();
                submitBtn.textContent = originalText;
                updateCustomSubjectVisibility();
            }, 2000);
        });
    }

    const dixaButton = document.getElementById('csDixaButton');
    if (dixaButton) {
        dixaButton.addEventListener('click', function(e) {
            e.preventDefault();

            const mobileMenuForDixa = document.getElementById('csMobileMenu');
            if (mobileMenuForDixa) {
                mobileMenuForDixa.style.display = 'none';
                mobileMenuForDixa.classList.remove('expanded');
            }

            if (typeof dixa !== 'undefined' && dixa._invoke) {
                dixa._invoke('setWidgetOpen', true);
                console.log('Opening Dixa chat with API');
            } else {
                console.warn('Dixa is not available yet - widget may still be loading');
            }
        });
    }

    const mobileMenu = document.getElementById('csMobileMenu');
    const mobileMenuToggle = document.getElementById('csMobileMenuToggle');

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            mobileMenu.classList.toggle('expanded');
        });
    }

    if (mobileMenu) {
        mobileMenu.addEventListener('click', function(e) {
            const menuItem = e.target.closest('.cs-mobile-menu-item');
            if (menuItem && menuItem.dataset.section) {
                e.preventDefault();
                const sectionId = menuItem.dataset.section;
                showSection(sectionId);

                mobileMenu.classList.remove('expanded');
            }
        });
    }

    if (mobileMenu) {
        let isDixaOpen = false;
        let isShopifyMenuOpen = false;

        let syncTimeout = null;
        const syncFloatingMenuLayer = () => {
            if (syncTimeout) clearTimeout(syncTimeout);
            syncTimeout = setTimeout(() => {
                if (isDixaOpen) {
                    mobileMenu.style.display = 'none';
                    mobileMenu.classList.add('hidden-for-dixa');
                    mobileMenu.classList.remove('lower-z-index');
                } else if (isShopifyMenuOpen) {
                    mobileMenu.style.display = '';
                    mobileMenu.style.zIndex = '10';
                    mobileMenu.classList.add('lower-z-index');
                    mobileMenu.classList.remove('hidden-for-dixa');
                } else {
                    mobileMenu.style.display = '';
                    mobileMenu.style.zIndex = '';
                    mobileMenu.classList.remove('hidden-for-dixa', 'lower-z-index');
                }
            }, 50);
        };

        const setupDixaEventListeners = () => {
            if (typeof _dixa_ !== 'undefined' && _dixa_.addListener) {
                _dixa_.addListener('on-widget-opened', () => {
                    isDixaOpen = true;
                    syncFloatingMenuLayer();
                    console.log('Dixa widget opened - hiding CS menu');
                });
                _dixa_.addListener('on-widget-closed', () => {
                    isDixaOpen = false;
                    syncFloatingMenuLayer();
                    console.log('Dixa widget closed - restoring CS menu');
                });
                return true;
            }
            if (typeof dixa !== 'undefined' && dixa.addListener) {
                dixa.addListener('on-widget-opened', () => {
                    isDixaOpen = true;
                    syncFloatingMenuLayer();
                });
                dixa.addListener('on-widget-closed', () => {
                    isDixaOpen = false;
                    syncFloatingMenuLayer();
                });
                return true;
            }
            return false;
        };

        if (!setupDixaEventListeners()) {
            setTimeout(() => setupDixaEventListeners(), 1000);
            setTimeout(() => setupDixaEventListeners(), 3000);
            setTimeout(() => setupDixaEventListeners(), 6000);
        }

        const observeDixaContainer = () => {
            const dixaSelectors = '[id*="dixa"], [class*="dixa"], [class*="Dixa"], .dixaWidget__overlay';
            const dixaElements = document.querySelectorAll(dixaSelectors);

            dixaElements.forEach(dixaContainer => {
                const dixaObserver = new MutationObserver(() => {
                    let anyDixaVisible = false;
                    document.querySelectorAll(dixaSelectors).forEach(el => {
                        const style = window.getComputedStyle(el);
                        const rect = el.getBoundingClientRect();
                        if (style.display !== 'none' && 
                            style.visibility !== 'hidden' && 
                            parseFloat(style.opacity) > 0.3 &&
                            rect.width > 150 && rect.height > 150) {
                            anyDixaVisible = true;
                        }
                    });

                    if (anyDixaVisible !== isDixaOpen) {
                        isDixaOpen = anyDixaVisible;
                        syncFloatingMenuLayer();
                    }
                });
                dixaObserver.observe(dixaContainer, { 
                    attributes: true, 
                    attributeFilter: ['style', 'class', 'aria-hidden', 'data-state', 'hidden'],
                    childList: true
                });
            });
        };
        observeDixaContainer();
        setTimeout(observeDixaContainer, 2000);
        setTimeout(observeDixaContainer, 5000);

        const setupShopifyMenuListeners = () => {
            const menuToggleSelectors = [
                '.header__icon--menu', '.menu-toggle', '[data-action="toggle-menu"]',
                '.mobile-nav-toggle', '.js-menu-toggle', 'header button[aria-controls*="menu"]',
                'header summary', '.header summary', '.header__menu-toggle',
                '[data-menu-toggle]', '.hamburger', '.burger-menu', '.nav-toggle',
                '.mobile-menu-toggle', 'button.menu', '[aria-label*="menu"]',
                '.header__icon--hamburger', '.site-header__menu-toggle'
            ];

            const menuToggles = document.querySelectorAll(menuToggleSelectors.join(', '));
            menuToggles.forEach(toggle => {
                toggle.addEventListener('click', () => {
                    setTimeout(checkShopifyMenuState, 50);
                    setTimeout(checkShopifyMenuState, 150);
                    setTimeout(checkShopifyMenuState, 300);
                });
            });

            const closeButtonSelectors = [
                '.menu-drawer__close', '.drawer__close', '[data-action="close-menu"]',
                '.menu-close', '.js-menu-close', '.close-menu', '[aria-label*="close"]',
                '.menu-drawer__close-button', '.drawer-close'
            ];
            const closeButtons = document.querySelectorAll(closeButtonSelectors.join(', '));
            closeButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        isShopifyMenuOpen = false;
                        syncFloatingMenuLayer();
                    }, 100);
                });
            });

            document.addEventListener('click', (e) => {
                if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;
                if (e.target.matches('.menu-drawer__overlay, .drawer-overlay, .nav-overlay, [class*="overlay"]')) {
                    setTimeout(() => {
                        isShopifyMenuOpen = false;
                        syncFloatingMenuLayer();
                    }, 100);
                }
            });
        };

        const checkShopifyMenuState = () => {
            const wasOpen = isShopifyMenuOpen;

            const panelScroller = document.querySelector('.panel__scroller');
            let panelOpen = false;
            if (panelScroller) {
                const panelParent = panelScroller.closest('[open], .is-open, [aria-hidden="false"]');
                if (panelParent) {
                    panelOpen = true;
                } else {
                    const style = window.getComputedStyle(panelScroller);
                    const rect = panelScroller.getBoundingClientRect();
                    if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 50) {
                        panelOpen = true;
                    }
                }
            }

            const navDrawer = document.querySelector('navigation-drawer[open], [is="navigation-drawer"][open]');

            const closeButton = document.querySelector('button[is="close-button"], .panel button[aria-label="Close"]');
            let closeButtonVisible = false;
            if (closeButton) {
                const style = window.getComputedStyle(closeButton);
                const rect = closeButton.getBoundingClientRect();
                if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0) {
                    closeButtonVisible = true;
                }
            }

            const openDrawerSelectors = [
                'menu-drawer[open]', '[data-menu-drawer][open]', 'details[open].menu-drawer',
                '.menu-drawer.is-open', '.menu-drawer--open', '.menu-drawer.active',
                '.drawer.is-open', '.drawer.active', '.drawer--open', '.drawer[open]',
                '.mobile-nav.is-open', '.mobile-nav.active', '.mobile-nav--open',
                '.menu-drawer__inner.is-open', '[aria-hidden="false"].menu-drawer',
                '.site-nav.is-open', '.header-menu.is-open',
                '.panel.is-open', '.panel[open]', '[class*="drawer"][open]'
            ];
            const openDrawer = document.querySelector(openDrawerSelectors.join(', '));

            const bodyClasses = document.body.className.toLowerCase();
            const openClassPatterns = [
                'drawer-open', 'js-drawer-open', 'drawer-opening',
                'overflow-hidden', 'no-scroll', 'menu-open', 'nav-open',
                'mobile-nav-open', 'is-open', 'has-open-drawer', 'freeze'
            ];
            const hasOpenClass = openClassPatterns.some(pattern => bodyClasses.includes(pattern));

            const htmlClasses = document.documentElement.className.toLowerCase();
            const hasHtmlOpenClass = openClassPatterns.some(pattern => htmlClasses.includes(pattern));

            const openDetails = document.querySelector(
                'header details[open], .header details[open], .shopify-section-header details[open], .site-header details[open]'
            );

            const visibleOverlay = document.querySelector(
                '.menu-drawer__overlay:not([hidden]), .drawer-overlay[aria-hidden="false"], ' +
                '.nav-overlay.is-visible, [class*="overlay"].is-open, .page-overlay.is-visible'
            );

            isShopifyMenuOpen = !!(panelOpen || navDrawer || closeButtonVisible || openDrawer || hasOpenClass || hasHtmlOpenClass || openDetails || visibleOverlay);

            if (wasOpen !== isShopifyMenuOpen) {
                syncFloatingMenuLayer();
            }
        };

        const observeShopifyDrawer = () => {
            const drawerSelectors = [
                'menu-drawer', '[data-menu-drawer]', '.menu-drawer',
                'header details', '.header details', '.drawer',
                '.panel', '.panel__scroller', 'navigation-drawer',
                '[is="navigation-drawer"]', 'button[is="close-button"]'
            ];
            const drawers = document.querySelectorAll(drawerSelectors.join(', '));

            drawers.forEach(drawer => {
                const drawerObserver = new MutationObserver(() => {
                    checkShopifyMenuState();
                });
                drawerObserver.observe(drawer, { 
                    attributes: true, 
                    attributeFilter: ['open', 'aria-hidden', 'class', 'style', 'hidden']
                });

                drawer.addEventListener('transitionend', checkShopifyMenuState);
            });
        };

        const bodyObserver = new MutationObserver(checkShopifyMenuState);
        bodyObserver.observe(document.body, { 
            attributes: true, 
            attributeFilter: ['class', 'style']
        });
        bodyObserver.observe(document.documentElement, { 
            attributes: true, 
            attributeFilter: ['class']
        });

        setupShopifyMenuListeners();
        observeShopifyDrawer();

        setInterval(() => {
            checkShopifyMenuState();
            const dixaContainer = document.querySelector('[id^="dixa"], [class*="dixa-messenger"]');
            if (dixaContainer) {
                const style = window.getComputedStyle(dixaContainer);
                const rect = dixaContainer.getBoundingClientRect();
                const nowOpen = style.display !== 'none' && 
                               style.visibility !== 'hidden' && 
                               parseFloat(style.opacity) > 0.3 &&
                               rect.width > 200 && rect.height > 200;
                if (nowOpen !== isDixaOpen) {
                    isDixaOpen = nowOpen;
                    syncFloatingMenuLayer();
                }
            }
        }, 500);

        checkShopifyMenuState();
        syncFloatingMenuLayer();
    }

    // ==========================================
    // UPDATED DEEP LINKING & NAVIGATION LOGIC
    // ==========================================

    // Handle all link clicks - fixes hash links from footer/external
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.cs-section, .cs-header, .cs-nav, .cs-mobile-menu')) return;
        const link = e.target.closest('a[href]');
        if (!link) return;

        const href = link.getAttribute('href');
        let hash = '';

        if (href.startsWith('#')) {
            hash = href.substring(1);
        } else if (href.includes('#')) {
            try {
                const linkUrl = new URL(href, window.location.origin);
                const currentUrl = new URL(window.location.href);
                if (linkUrl.pathname === currentUrl.pathname && linkUrl.hash) {
                    hash = linkUrl.hash.substring(1);
                }
            } catch (err) { return; }
        }

        if (hash) {
            if (hash.includes('.')) return;
            e.preventDefault();
            handleDeepLink(hash);
        }
    });

    // Main function to handle deep linking (FAQs, Sections, etc)
    function handleDeepLink(hashOverride) {
        let hash = hashOverride || window.location.hash.substring(1);

        if (!hash) {
            if (!document.querySelector('.cs-section.page-active')) {
                showSection('orders');
            }
            return;
        }

        let sectionToShow = 'orders';
        let elementToScrollTo = null;
        const originalHash = hash;

        // Parse dot notation (e.g. orders.faq-orders-arrival)
        if (hash.includes('.')) {
            const parts = hash.split('.');
            sectionToShow = parts[0];
            elementToScrollTo = document.getElementById(parts[1]);
            
            if (document.getElementById(sectionToShow)) {
                showSection(sectionToShow);
            }
        } else {
            const targetElement = document.getElementById(hash);
            if (targetElement) {
                if (targetElement.classList.contains('cs-section')) {
                    sectionToShow = hash;
                } else {
                    const parentSection = targetElement.closest('.cs-section');
                    if (parentSection) {
                        sectionToShow = parentSection.id;
                        elementToScrollTo = targetElement;
                    }
                }
            } else {
                if (document.getElementById(hash) && document.getElementById(hash).classList.contains('cs-section')) {
                    sectionToShow = hash;
                }
            }
            showSection(sectionToShow);
        }

        // Force URL to stay correct (fixes Shopify theme overrides)
        setTimeout(() => {
            if (window.location.hash !== '#' + originalHash) {
                const url = new URL(window.location);
                url.hash = originalHash;
                window.history.replaceState({}, '', url);
            }
        }, 50);

        // Open accordion and scroll
        if (elementToScrollTo) {
            if (elementToScrollTo.classList.contains('faq-item')) {
                document.querySelectorAll('.faq-item').forEach(item => item.classList.remove('active'));
                elementToScrollTo.classList.add('active');
            }

            // Scroll with delay to allow UI and animations to finish
            setTimeout(() => {
                elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 450);
        }
    }

    // Handle Browser Back/Forward buttons
    window.addEventListener('popstate', function() {
        handleDeepLink();
    });

    // Handle manual hash changes
    window.addEventListener('hashchange', function() {
        handleDeepLink();
    });

    // Initialize on page load (with delay to ensure DOM is ready)
    setTimeout(function() {
        handleDeepLink();
    }, 100);
});

// Also handle window load event for Shopify compatibility
window.addEventListener('load', function() {
    // Re-check hash on full page load (catches Shopify section lazy loading)
    const hash = window.location.hash.substring(1);
    if (hash) {
        // Trigger the deep link handler
        const event = new Event('hashchange');
        window.dispatchEvent(event);
    }
});

// Invoice download function - generates printable invoice
window.downloadInvoice = function(orderNumber, orderDate, locale) {
    const orderCard = document.querySelector('.order-card');
    if (!orderCard) return;

    // Track invoice download for France store
    fetch('https://bwj-customer-service.replit.app/api/analytics/invoice-download', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ store: 'fr' })
    }).catch(() => {});

    const orderNumberText = orderCard.querySelector('.order-number')?.textContent || orderNumber;
    const totalValue = orderCard.querySelector('.order-total-value')?.textContent || '';
    const statusBadge = orderCard.querySelector('.order-status-badge')?.textContent || '';
    const paymentStatus = orderCard.querySelectorAll('.order-detail-value')[0]?.textContent || '';
    const carrier = orderCard.querySelectorAll('.order-detail-value')[1]?.textContent || '';
    const shippingTo = orderCard.querySelectorAll('.order-detail-value')[2]?.textContent || '';
    const contactEmail = orderCard.querySelectorAll('.order-detail-value')[3]?.textContent || '';

    const customerName = orderCard.getAttribute('data-customer-name') || '';
    const customerPhone = orderCard.getAttribute('data-phone') || '';

    // Get financial breakdown data
    const subtotalValue = orderCard.getAttribute('data-subtotal') || '0.00';
    const taxValue = orderCard.getAttribute('data-tax') || '0.00';
    const discountsValue = orderCard.getAttribute('data-discounts') || '0.00';
    const shippingCostValue = orderCard.getAttribute('data-shipping-cost') || '0.00';
    const grandTotalValue = orderCard.getAttribute('data-total') || '0.00';
    const currencySymbol = orderCard.getAttribute('data-currency') || '€';
    const taxesIncluded = orderCard.getAttribute('data-taxes-included') === 'true';

    // Parse tax lines for detailed breakdown
    let taxLines = [];
    try {
        const taxLinesJSON = orderCard.getAttribute('data-tax-lines');
        if (taxLinesJSON) {
            taxLines = JSON.parse(taxLinesJSON);
        }
    } catch (e) {
        console.error('Error parsing tax lines:', e);
    }

    let shippingAddress = null;
    let billingAddress = null;
    try {
        const shippingJSON = orderCard.getAttribute('data-shipping-address');
        if (shippingJSON) {
            shippingAddress = JSON.parse(shippingJSON.replace(/&quot;/g, '"'));
        }
        const billingJSON = orderCard.getAttribute('data-billing-address');
        if (billingJSON) {
            billingAddress = JSON.parse(billingJSON.replace(/&quot;/g, '"'));
        }
    } catch (e) {
        console.error('Error parsing address data:', e);
    }

    const itemElements = orderCard.querySelectorAll('.order-item');
    let itemsHTML = '';
    itemElements.forEach(item => {
        const name = item.querySelector('.order-item-name')?.textContent || '';
        const qty = item.querySelector('.order-item-qty')?.textContent || '';
        const price = item.querySelector('.order-item-price')?.textContent || '';
        itemsHTML += `
            <tr>
                <td>${name}</td>
                <td style="text-align: center;">${qty.replace('Qté: ', '')}</td>
                <td style="text-align: right; font-weight: 600;">${price}</td>
            </tr>
        `;
    });

    const t = translations[locale] || translations['fr-FR'];
    const invoiceDate = new Date().toLocaleDateString(locale);

    const countryLogos = {
        'FR': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/bsw_logo_horizontal_small_rgb.png?v=1729582729',
        'UK': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/sws_logo_horizontal_small_rgb.png?v=1729582729',
        'GB': 'https://cdn.shopify.com/s/files/1/0879/7120/1300/files/sws_logo_horizontal_small_rgb.png?v=1729582729'
    };

    const normalizeCountry = (countryStr) => {
        if (!countryStr) return '';
        const normalized = countryStr.toUpperCase().trim();

        const countryNameMap = {
            'UNITED KINGDOM': 'GB',
            'GREAT BRITAIN': 'GB',
            'ENGLAND': 'GB',
            'SCOTLAND': 'GB',
            'WALES': 'GB',
            'GERMANY': 'DE',
            'DEUTSCHLAND': 'DE',
            'NETHERLANDS': 'NL',
            'NEDERLAND': 'NL',
            'SPAIN': 'ES',
            'ESPAÑA': 'ES',
            'FRANCE': 'FR'
        };

        if (countryNameMap[normalized]) {
            return countryNameMap[normalized];
        }

        return normalized;
    };

    const rawCountry = shippingAddress?.countryCodeV2 || shippingAddress?.countryCode || shippingAddress?.country_code || shippingAddress?.country || 'FR';
    const country = normalizeCountry(rawCountry);
    const logoURL = countryLogos[country] || countryLogos['FR'];

    console.log('Invoice country detection:', { rawCountry, country, logoURL });

    const escapeHTML = (str) => {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    const formatAddress = (addr) => {
        if (!addr) return '';
        const parts = [];
        if (addr.address1) parts.push(escapeHTML(addr.address1));
        if (addr.address2) parts.push(escapeHTML(addr.address2));
        const cityLine = [addr.city, addr.province, addr.zip].filter(Boolean).map(escapeHTML).join(', ');
        if (cityLine) parts.push(cityLine);
        if (addr.country) parts.push(escapeHTML(addr.country));
        return parts.filter(Boolean).join('<br>');
    };

    let shippingAddressHTML = '';
    if (shippingAddress) {
        const fullName = [shippingAddress.firstName, shippingAddress.lastName].filter(Boolean).map(escapeHTML).join(' ');
        const phone = escapeHTML(shippingAddress.phone || customerPhone);
        const addressFormatted = formatAddress(shippingAddress);
        shippingAddressHTML = `
            ${shippingAddress.company ? `<p><strong>${t.company || 'Entreprise'}:</strong> ${escapeHTML(shippingAddress.company)}</p>` : ''}
            ${fullName ? `<p><strong>Nom:</strong> ${fullName}</p>` : ''}
            ${addressFormatted ? `<p><strong>Adresse:</strong><br>${addressFormatted}</p>` : `<p><strong>Expédié à:</strong> ${escapeHTML(shippingTo)}</p>`}
            ${phone ? `<p><strong>Téléphone:</strong> ${phone}</p>` : ''}
            <p><strong>E-mail:</strong> ${escapeHTML(contactEmail)}</p>
        `;
    } else {
        shippingAddressHTML = `
            ${customerName ? `<p><strong>Client:</strong> ${escapeHTML(customerName)}</p>` : ''}
            <p><strong>${t.shippingTo}:</strong> ${escapeHTML(shippingTo)}</p>
            ${customerPhone ? `<p><strong>Téléphone:</strong> ${escapeHTML(customerPhone)}</p>` : ''}
            <p><strong>E-mail:</strong> ${escapeHTML(contactEmail)}</p>
        `;
    }

    let billingAddressHTML = '';
    if (billingAddress) {
        const fullName = [billingAddress.firstName, billingAddress.lastName].filter(Boolean).map(escapeHTML).join(' ');
        const phone = escapeHTML(billingAddress.phone || customerPhone);
        billingAddressHTML = `
            <div class="info-section">
                <h3>Détails de Facturation</h3>
                ${billingAddress.company ? `<p><strong>${t.company || 'Entreprise'}:</strong> ${escapeHTML(billingAddress.company)}</p>` : ''}
                ${fullName ? `<p><strong>Nom:</strong> ${fullName}</p>` : ''}
                ${formatAddress(billingAddress) ? `<p><strong>Adresse:</strong><br>${formatAddress(billingAddress)}</p>` : ''}
                ${phone ? `<p><strong>Téléphone:</strong> ${phone}</p>` : ''}
                <p><strong>E-mail:</strong> ${escapeHTML(contactEmail)}</p>
            </div>
        `;
    }

    const invoiceHTML = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
            <title>Facture - ${orderNumberText}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
                    padding: 2rem;
                    background: #F8FAFC;
                }
                .invoice-container {
                    max-width: 800px;
                    margin: 0 auto;
                    background: white;
                    padding: 2rem;
                    border-radius: 12px;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
                }
                .invoice-disclaimer {
                    background: #FFF9F5;
                    border-left: 4px solid #FF4F01;
                    padding: 0.75rem 1rem;
                    margin-bottom: 1.5rem;
                    border-radius: 6px;
                }
                .invoice-disclaimer p {
                    font-size: 0.8rem;
                    color: #64748B;
                    font-style: italic;
                }
                .invoice-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 1.5rem;
                    padding-bottom: 1.5rem;
                    border-bottom: 3px solid #FF4F01;
                }
                .company-logo {
                    max-width: 200px;
                    height: auto;
                    margin-bottom: 0.5rem;
                }
                .company-info h1 {
                    font-size: 1.75rem;
                    color: #FF4F01;
                    margin-bottom: 0.25rem;
                }
                .company-info p {
                    color: #64748B;
                    line-height: 1.4;
                    font-size: 0.875rem;
                }
                .invoice-details {
                    text-align: right;
                }
                .invoice-details h2 {
                    font-size: 1.5rem;
                    color: #0F172A;
                    margin-bottom: 0.5rem;
                }
                .invoice-details p {
                    color: #64748B;
                    line-height: 1.8;
                }
                .order-info {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 1rem;
                    margin-bottom: 1.5rem;
                    padding: 1rem;
                    background: #F8FAFC;
                    border-radius: 8px;
                }
                .info-section h3 {
                    font-size: 0.75rem;
                    color: #64748B;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-bottom: 0.5rem;
                }
                .info-section p {
                    color: #0F172A;
                    line-height: 1.5;
                    font-size: 0.875rem;
                    margin-bottom: 0.25rem;
                }
                .items-table {
                    width: 100%;
                    margin-bottom: 1rem;
                    border-collapse: collapse;
                }
                .items-table thead {
                    background: linear-gradient(135deg, #FF4F01, #FF6B2B);
                    color: white;
                }
                .items-table th {
                    padding: 0.75rem;
                    text-align: left;
                    font-weight: 600;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .items-table th:nth-child(2) { text-align: center; }
                .items-table th:nth-child(3) { text-align: right; }
                .items-table td {
                    padding: 0.5rem 0.75rem;
                    font-size: 0.875rem;
                }
                .invoice-totals {
                    margin-top: 1.5rem;
                    padding: 1rem;
                    background: #F8FAFC;
                    border-radius: 8px;
                }
                .totals-table {
                    width: 100%;
                    max-width: 350px;
                    margin-left: auto;
                    border-collapse: collapse;
                }
                .totals-table td {
                    padding: 0.5rem 0;
                    font-size: 0.95rem;
                    color: #475569;
                }
                .totals-table td.amount {
                    text-align: right;
                    font-weight: 600;
                    color: #0F172A;
                }
                .totals-table .discount-row td {
                    color: #16a34a;
                }
                .totals-table .grand-total-row td {
                    padding-top: 0.75rem;
                    border-top: 2px solid #E2E8F0;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #0F172A;
                }
                .totals-table .grand-total-row td.amount {
                    color: #FF4F01;
                    font-size: 1.25rem;
                }
                .invoice-footer {
                    margin-top: 1.5rem;
                    padding-top: 1rem;
                    border-top: 1px solid #E2E8F0;
                    text-align: center;
                    color: #64748B;
                    font-size: 0.8rem;
                }

                /* Mobile Responsive Styles */
                @media (max-width: 768px) {
                    body {
                        padding: 0.5rem;
                    }
                    .invoice-container {
                        padding: 1rem;
                        border-radius: 8px;
                    }
                    .invoice-disclaimer {
                        padding: 0.5rem 0.75rem;
                        margin-bottom: 1rem;
                    }
                    .invoice-disclaimer p {
                        font-size: 0.75rem;
                    }
                    .invoice-header {
                        flex-direction: column;
                        gap: 1rem;
                        margin-bottom: 1rem;
                        padding-bottom: 1rem;
                    }
                    .company-logo {
                        max-width: 150px;
                    }
                    .company-info h1 {
                        font-size: 1.25rem;
                    }
                    .company-info p {
                        font-size: 0.8rem;
                    }
                    .invoice-details {
                        text-align: left;
                    }
                    .invoice-details h2 {
                        font-size: 1.25rem;
                    }
                    .invoice-details p {
                        font-size: 0.8rem;
                    }
                    .order-info {
                        grid-template-columns: repeat(3, 1fr) !important;
                        gap: 0.5rem;
                        padding: 0.75rem;
                        margin-bottom: 1rem;
                    }
                    .info-section h3 {
                        font-size: 0.7rem;
                    }
                    .info-section p {
                        font-size: 0.8rem;
                    }
                    .items-table {
                        font-size: 0.8rem;
                    }
                    .items-table th {
                        padding: 0.5rem 0.25rem;
                        font-size: 0.7rem;
                    }
                    .items-table td {
                        padding: 0.4rem 0.25rem;
                        font-size: 0.8rem;
                    }
                    .invoice-totals {
                        padding: 0.75rem;
                    }
                    .totals-table {
                        max-width: 100%;
                    }
                    .totals-table td {
                        font-size: 0.85rem;
                    }
                    .totals-table .grand-total-row td.amount {
                        font-size: 1.1rem;
                    }
                    .invoice-footer {
                        margin-top: 1rem;
                        font-size: 0.75rem;
                    }
                }

                @media print {
                    body { background: white; padding: 0; }
                    .invoice-container { box-shadow: none; padding: 1.5rem; }
                    @page { margin: 1cm; }
                }
            </style>
        </head>
        <body>
            <div class="invoice-container">
                <div class="invoice-disclaimer">
                    <p><strong>Note:</strong> Ceci est une facture générée pour vos archives. Votre facture officielle a été envoyée à votre adresse e-mail lors de l'achat.</p>
                </div>

                <div class="invoice-header">
                    <div class="company-info">
                        ${logoURL ? `<img src="${logoURL}" alt="Braceletsmartwatch.fr" class="company-logo">` : '<h1>Braceletsmartwatch.fr</h1>'}
                        <p>Bracelets et Accessoires de Montre Premium</p>
                        <p>service@braceletsmartwatch.fr</p>
                    </div>
                    <div class="invoice-details">
                        <h2>${t.invoice || 'Facture'}</h2>
                        <p><strong>${t.date || 'Date'}:</strong> ${invoiceDate}</p>
                        <p><strong>${t.orderNumber}:</strong> ${orderNumber}</p>
                    </div>
                </div>

                <div class="order-info">
                    <div class="info-section">
                        <h3>${t.orderDetails || 'Détails de la commande'}</h3>
                        <p><strong>${t.placedOn}:</strong> ${orderDate}</p>
                        <p><strong>${t.status || 'Statut'}:</strong> ${statusBadge}</p>
                        <p><strong>${t.paymentStatus}:</strong> ${paymentStatus}</p>
                        <p><strong>${t.carrier}:</strong> ${carrier}</p>
                    </div>
                    <div class="info-section">
                        <h3>${t.shippingDetails || 'Détails d\'expédition'}</h3>
                        ${shippingAddressHTML}
                    </div>
                    ${billingAddressHTML}
                </div>

                <table class="items-table">
                    <thead>
                        <tr>
                            <th>${t.item || 'Article'}</th>
                            <th>${t.quantity || 'Quantité'}</th>
                            <th>${t.price || 'Prix'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${itemsHTML}
                    </tbody>
                </table>

                <div class="invoice-totals">
                    <table class="totals-table">
                        <tbody>
                            <tr>
                                <td>${t.subtotal || 'Sous-total'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(subtotalValue).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>${t.shipping || 'Frais de livraison'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(shippingCostValue).toFixed(2)}</td>
                            </tr>
                            ${parseFloat(discountsValue) > 0 ? `
                            <tr class="discount-row">
                                <td>${t.discount || 'Remise'}</td>
                                <td class="amount">-${currencySymbol}${parseFloat(discountsValue).toFixed(2)}</td>
                            </tr>
                            ` : ''}
                            ${taxLines.length > 0 ? taxLines.map(line => `
                            <tr>
                                <td>${line.title}${line.ratePercentage ? ` (${line.ratePercentage}%)` : ''}${taxesIncluded ? ' (inclus)' : ''}</td>
                                <td class="amount">${currencySymbol}${parseFloat(line.price).toFixed(2)}</td>
                            </tr>
                            `).join('') : `
                            <tr>
                                <td>${t.tax || 'TVA'}${taxesIncluded ? ' (inclus)' : ''}</td>
                                <td class="amount">${currencySymbol}${parseFloat(taxValue).toFixed(2)}</td>
                            </tr>
                            `}
                            <tr class="grand-total-row">
                                <td>${t.grandTotal || 'Total à payer'}</td>
                                <td class="amount">${currencySymbol}${parseFloat(grandTotalValue).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="invoice-footer">
                    <p>${t.thankYou || 'Merci pour votre achat !'}</p>
                    <p style="margin-top: 1rem;">Braceletsmartwatch.fr © ${new Date().getFullYear()}</p>
                </div>
            </div>
        </body>
        </html>
    `;

    const invoiceWindow = window.open('', '_blank');
    if (invoiceWindow) {
        invoiceWindow.document.write(invoiceHTML);
        invoiceWindow.document.close();

        invoiceWindow.onload = function() {
            invoiceWindow.print();
        };
    } else {
        alert(t.popupBlocked || 'Veuillez autoriser les pop-ups pour télécharger la facture');
    }
};

// Helper function to generate carrier-specific tracking URL
function getTrackingUrl(carrier, trackingNumber, postcode) {
    let carrierConfig = carrierRegistry[carrier];

    if (!carrierConfig) {
        const carrierKey = Object.keys(carrierRegistry).find(
            key => key.toLowerCase() === carrier.toLowerCase()
        );
        if (carrierKey) {
            carrierConfig = carrierRegistry[carrierKey];
        }
    }

    if (carrierConfig && carrierConfig.urlTemplate) {
        try {
            return carrierConfig.urlTemplate(trackingNumber, postcode);
        } catch (error) {
            console.warn('Error generating tracking URL:', error);
        }
    }

    // Fallback to La Poste for France
    return `https://www.laposte.fr/outils/suivre-vos-envois?code=${encodeURIComponent(trackingNumber)}`;
}

window.lookupOrder = async function() {
    const orderNumber = document.getElementById('orderNumber').value.trim();
    const orderEmail = document.getElementById('orderEmail').value.trim();
    const resultsDiv = document.getElementById('orderResults');
    const lookupBtn = document.getElementById('lookupBtn');

    if (!orderNumber || !orderEmail) return;

    const apiUrl = typeof API_ENDPOINT !== 'undefined' ? API_ENDPOINT : 'https://actium.automagically.nl/webhook/track-order';
    console.log('Looking up order:', orderNumber, 'with API:', apiUrl);

    const loadingText = translations['fr-FR'].searching;
    lookupBtn.disabled = true;
    lookupBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" opacity="0.25"></circle><path d="M4 12a8 8 0 0 1 8-8" opacity="0.75"></path></svg> ${loadingText}`;

    try {
        console.log('Fetching from API...');
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ orderNumber, email: orderEmail, country: 'FR' })
        });

        const data = await response.json();

        const locale = data.locale || 'fr-FR';
        const t = translations[locale] || translations['fr-FR'];

        if (!response.ok || data.error) {
            if (data.error) {
                console.log('Server error:', data.error);
            }

            // Dynamische Auswahl des Fehlertextes basierend auf dem errorType von n8n
            const errorText = data.errorType === 'connection' ? t.connectionError : t.orderNotFound;

            resultsDiv.innerHTML = `
                <div class="order-error">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <p>${errorText}</p>
                </div>
            `;
            resultsDiv.style.display = 'block';

            lookupBtn.disabled = false;
            lookupBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
                ${t.findMyOrder}
            `;
            return;
        }

        // Track successful order search for France store
        fetch('https://bwj-customer-service.replit.app/api/analytics/order-search', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ store: 'fr' })
        }).catch(() => {});

        const currencySymbol = data.currencySymbol || '€';

        const statusClass = data.status === 'Shipped' ? 'status-shipped' : 
                          data.status === 'Processing' ? 'status-processing' : 'status-pending';

        const statusMap = {
            'Shipped': t.shipped,
            'Processing': t.processing,
            'Pending Payment': t.pending
        };
        const translatedStatus = statusMap[data.status] || data.status;

        const financialStatusMap = {
            'Paid': t.paid,
            'Unpaid': t.unpaid,
            'Refunded': t.refunded,
            'Pending': t.pending
        };
        const translatedFinancialStatus = financialStatusMap[data.financialStatus] || data.financialStatus;

        const hasValidTracking = (trackingNum) => {
            if (!trackingNum) return false;
            const normalized = String(trackingNum).trim().toLowerCase();
            const invalidSentinels = [
                'not yet shipped',
                'not available',
                'no tracking provided',
                'pending',
                'n/a',
                'none',
                ''
            ];
            return !invalidSentinels.includes(normalized);
        };

        let trackingButtonHTML = '';

        if (hasValidTracking(data.trackingNumber)) {
            const trackingUrl = getTrackingUrl(data.carrier, data.trackingNumber, data.shippingAddress?.zip);
            trackingButtonHTML = `<a href="${trackingUrl}" target="_blank" rel="noopener noreferrer" class="lookup-btn" style="padding: 0.625rem 1.25rem; font-size: 0.9375rem; white-space: nowrap;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 18px; height: 18px;"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>${t.trackPackage}</a>`;
        } else {
            const messageText = (data.status === 'Shipped') 
                ? (t.untrackedDelivery || 'Votre commande a été expédiée et est en route.')
                : (t.trackingAvailableSoon || 'Suivi disponible bientôt');

            trackingButtonHTML = `<div class="tracking-status-message" style="padding: 0.625rem 1.25rem; font-size: 0.875rem; color: var(--text-muted); background: rgba(255, 165, 0, 0.1); border-radius: 0.5rem; max-width: 100%; overflow-wrap: break-word; word-wrap: break-word; hyphens: auto;">${messageText}</div>`;
        }

        const itemsHTML = data.lineItems.map(item => {
            const itemTitle = item.title || item.name;
            return `
            <div class="order-item">
                <div>
                    <div class="order-item-name">${itemTitle}</div>
                    <span class="order-item-qty">${t.qty}: ${item.quantity}</span>
                </div>
                <div class="order-item-price">${currencySymbol}${parseFloat(item.price).toFixed(2)}</div>
            </div>
        `;
        }).join('');

        let shippingHTML = '';
        if (data.shippingAddress) {
            shippingHTML = `
                <div class="order-detail">
                    <div class="order-detail-label">${t.shippingTo}</div>
                    <div class="order-detail-value">${data.shippingAddress.city}, ${data.shippingAddress.country}</div>
                </div>
            `;
        }

        const customerFullName = data.shippingAddress && data.shippingAddress.firstName && data.shippingAddress.lastName ? 
            `${data.shippingAddress.firstName} ${data.shippingAddress.lastName}` : '';
        const escapedCustomerName = customerFullName.replace(/"/g, '&quot;');

        // Check if this is a FR order (invoice available for FR orders)
        const shippingCountry = data.shippingAddress?.country || '';
        const shippingCountryCode = data.shippingAddress?.countryCode || '';
        const isFROrder = shippingCountry === 'France' || 
                          shippingCountryCode === 'FR';

        // Helper function to add working days (excludes weekends)
        const addWorkingDays = (date, days) => {
            const result = new Date(date);
            let addedDays = 0;
            while (addedDays < days) {
                result.setDate(result.getDate() + 1);
                if (result.getDay() !== 0 && result.getDay() !== 6) {
                    addedDays++;
                }
            }
            result.setHours(0, 0, 0, 0);
            return result;
        };

        // Helper function to check if current month is a busy shopping season
        const isBusyShoppingSeason = () => {
            const today = new Date();
            const month = today.getMonth();
            return month === 10 || month === 11 || month === 0;
        };

        // Calculate delivery prediction if we have a ship date
        let deliveryPredictionHTML = '';
        console.log('Ship date from API:', data.shipDate);
        if (data.shipDate) {
            console.log('Ship date exists, calculating prediction');
            const shipDate = new Date(data.shipDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Calculate 3-7 working days from ship date (FR delivery window)
            const earliestDate = addWorkingDays(shipDate, 3);
            const latestDate = addWorkingDays(shipDate, 7);

            // Buffer before showing "delayed" notification (8 working days)
            const delayedNotificationDate = addWorkingDays(shipDate, 8);

            // Extended window for "significantly delayed" / contact us message (12 working days)
            const delayedThreshold = addWorkingDays(shipDate, 12);

            // Check if order has been delivered
            const hasArchivedTag = data.tags && data.tags.includes('Gearchiveerd');
            const isDelivered = data.shipmentStatus === 'delivered' || hasArchivedTag;

            // Format dates with day name and date in French
            const formatDateWithDay = (date) => {
                const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
                const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
                const dayName = days[date.getDay()];
                const day = date.getDate();
                const month = months[date.getMonth()];
                return `${day} ${month} ${dayName}`;
            };

            const earliestFormatted = formatDateWithDay(earliestDate);
            const latestFormatted = formatDateWithDay(latestDate);

            // Seasonal delay message for busy shopping months (in French)
            const seasonalMessage = isBusyShoppingSeason() ? `
                <div style="background: linear-gradient(135deg, #FFF9F0 0%, #FFE5CC 100%); border-left: 4px solid #F59E0B; padding: 0.75rem 1rem; border-radius: 0.5rem; margin-bottom: 0.75rem;">
                    <div style="display: flex; align-items: center; gap: 0.5rem;">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#F59E0B" stroke-width="2" style="width: 18px; height: 18px; flex-shrink: 0;">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                        </svg>
                        <p style="margin: 0; font-size: 0.85rem; color: #92400E; font-weight: 600;">Avis Période des Fêtes</p>
                    </div>
                    <p style="margin: 0.5rem 0 0 1.75rem; font-size: 0.8rem; color: #78350F;">En raison du volume élevé pendant la période des fêtes, certaines livraisons peuvent subir de légers retards. Merci de votre patience !</p>
                </div>
            ` : '';

            // Determine what to show based on timing and delivery status
            if (isDelivered) {
                deliveryPredictionHTML = '';
            } else if (today > delayedThreshold) {
                // More than 10 working days past ship date - show urgent delay message
                const shipDateFormatted = formatDateWithDay(shipDate);
                deliveryPredictionHTML = `
                    ${seasonalMessage}
                    <div style="background: linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%); border: 2px solid rgba(220, 38, 38, 0.3); border-radius: 0.75rem; padding: 1rem; margin-top: 1rem; margin-bottom: 1.5rem;">
                        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem;">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" style="width: 24px; height: 24px; flex-shrink: 0;">
                                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                <line x1="12" y1="9" x2="12" y2="13"></line>
                                <line x1="12" y1="17" x2="12.01" y2="17"></line>
                            </svg>
                            <h4 style="margin: 0; font-size: 1rem; font-weight: 600; color: #1F2937;">Livraison Significativement Retardée</h4>
                        </div>
                        <p style="margin: 0 0 1rem 0; color: #6B7280; font-size: 0.9375rem; line-height: 1.5;">
                            Votre commande a un retard important. Le délai de livraison prévu est dépassé. Nous vous recommandons de nous contacter immédiatement pour obtenir de l'aide.
                        </p>
                        <div style="display: flex; flex-direction: column; gap: 0.5rem; font-size: 0.875rem; margin-bottom: 1rem;">
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <span style="color: #6B7280;">Commande passée :</span>
                                <span style="color: #1F2937; font-weight: 600;">${translateDateToFrench(data.orderDate)}</span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" style="width: 16px; height: 16px;">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                                <span style="color: #6B7280;">Commande expédiée :</span>
                                <span style="color: #1F2937; font-weight: 600;">${shipDateFormatted}</span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" style="width: 16px; height: 16px;">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                                <span style="color: #6B7280;">Livraison prévue :</span>
                                <span style="color: #DC2626; font-weight: 600;">${earliestFormatted} - ${latestFormatted}</span>
                            </div>
                        </div>
                        <p style="margin: 0; padding-top: 0.75rem; border-top: 1px solid rgba(220, 38, 38, 0.2); font-size: 0.875rem; color: #1F2937; font-weight: 600;">
                            Veuillez <a href="#contact" onclick="showSection('contact'); setTimeout(() => document.getElementById('name').focus(), 300); return false;" style="color: #DC2626; text-decoration: underline; font-weight: 700;">nous contacter maintenant</a> afin que nous puissions enquêter et vous aider à résoudre ce problème.
                        </p>
                    </div>
                `;
            } else if (today > delayedNotificationDate) {
                const shipDateFormatted = formatDateWithDay(shipDate);
                
                // Smart dynamic date calculation: Prevent showing past dates as "new expectations"
                let dynamicEarliest = earliestDate;
                let dynamicLatest = addWorkingDays(latestDate, 2);

                if (today >= dynamicLatest) {
                    dynamicEarliest = addWorkingDays(today, 1);
                    dynamicLatest = addWorkingDays(today, 3);
                } else if (today >= dynamicEarliest) {
                    dynamicEarliest = addWorkingDays(today, 1);
                    if (dynamicLatest <= dynamicEarliest) {
                        dynamicLatest = addWorkingDays(dynamicEarliest, 2);
                    }
                }

                const extendedEarliestFormatted = formatDateWithDay(dynamicEarliest);
                const extendedLatestFormatted = formatDateWithDay(dynamicLatest);

                deliveryPredictionHTML = `
                    ${seasonalMessage}
                    <div style="background: linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%); border: 2px solid rgba(255, 152, 0, 0.3); border-radius: 0.75rem; padding: 0.875rem; margin-top: 1rem; margin-bottom: 1.5rem;">
                        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                            <svg viewBox="0 0 24 24" fill="none" stroke="#F57C00" stroke-width="2" style="width: 20px; height: 20px; flex-shrink: 0;">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="12"></line>
                                <line x1="12" y1="16" x2="12.01" y2="16"></line>
                            </svg>
                            <h4 style="margin: 0; font-size: 0.95rem; font-weight: 600; color: #92400E;">Léger Retard</h4>
                        </div>
                        <p style="margin: 0 0 0.625rem 0; color: #78350F; font-size: 0.85rem; line-height: 1.4;">
                            Malheureusement, votre commande prend un peu plus de temps que prévu. En raison du volume du transporteur ou des conditions météorologiques, la livraison est légèrement retardée. Ne vous inquiétez pas, votre colis arrive généralement sous quelques jours supplémentaires.
                        </p>
                        <div style="display: flex; flex-wrap: wrap; gap: 0.375rem; font-size: 0.75rem;">
                            <span style="background: rgba(245, 158, 11, 0.15); color: #92400E; padding: 0.25rem 0.5rem; border-radius: 0.375rem;">Expédié : ${shipDateFormatted}</span>
                            <span style="background: rgba(245, 158, 11, 0.25); color: #92400E; padding: 0.25rem 0.5rem; border-radius: 0.375rem; font-weight: 600;">Nouvelle estimation : ${extendedEarliestFormatted} - ${extendedLatestFormatted}</span>
                        </div>
                    </div>
                `;
            } else {
                // Within expected delivery window - show normal prediction
                const shipDateFormatted = formatDateWithDay(shipDate);
                deliveryPredictionHTML = `
                    ${seasonalMessage}
                    <div style="background: linear-gradient(135deg, #FFF5F2 0%, #FFE8DB 100%); border: 2px solid rgba(255, 79, 1, 0.2); border-radius: 0.75rem; padding: 1rem; margin-top: 1rem; margin-bottom: 1.5rem;">
                        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem;">
                            <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary-orange)" stroke-width="2" style="width: 24px; height: 24px; flex-shrink: 0;">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                            </svg>
                            <h4 style="margin: 0; font-size: 1rem; font-weight: 600; color: #1F2937;">Livraison Estimée</h4>
                        </div>
                        <p style="margin: 0 0 1rem 0; color: #6B7280; font-size: 0.9375rem; line-height: 1.5;">
                            Votre commande devrait arriver sous <strong style="color: var(--primary-orange);">2 à 4 jours ouvrables</strong> à compter de son expédition.
                        </p>
                        <div style="display: flex; flex-direction: column; gap: 0.5rem; font-size: 0.875rem;">
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <span style="color: #6B7280;">Commande passée :</span>
                                <span style="color: #1F2937; font-weight: 600;">${translateDateToFrench(data.orderDate)}</span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary-orange)" stroke-width="2" style="width: 16px; height: 16px;">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                                <span style="color: #6B7280;">Commande expédiée :</span>
                                <span style="color: #1F2937; font-weight: 600;">${shipDateFormatted}</span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary-orange)" stroke-width="2" style="width: 16px; height: 16px;">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                                <span style="color: #6B7280;">Arrivée estimée entre :</span>
                                <span style="color: var(--primary-orange); font-weight: 600;">${earliestFormatted} - ${latestFormatted}</span>
                            </div>
                        </div>
                    </div>
                `;
            }
        }

        // Prepare address data for invoice
        const shippingAddressJSON = data.shippingAddress ? JSON.stringify(data.shippingAddress).replace(/"/g, '&quot;') : '';
        const billingAddressJSON = data.billingAddress ? JSON.stringify(data.billingAddress).replace(/"/g, '&quot;') : '';
        const customerPhone = (data.phone || '').replace(/"/g, '&quot;');

        resultsDiv.innerHTML = `
            <div class="order-card" 
                data-customer-name="${escapedCustomerName}"
                data-shipping-address="${shippingAddressJSON}"
                data-billing-address="${billingAddressJSON}"
                data-phone="${customerPhone}"
                data-subtotal="${data.subtotalPrice || '0.00'}"
                data-tax="${data.totalTax || '0.00'}"
                data-discounts="${data.totalDiscounts || '0.00'}"
                data-shipping-cost="${data.totalShippingPrice || '0.00'}"
                data-total="${data.totalPrice || '0.00'}"
                data-currency="${currencySymbol}"
                data-tax-lines='${JSON.stringify(data.taxLines || [])}'
                data-taxes-included="${data.taxesIncluded || false}">
                <div class="order-header">
                    <div>
                        <div class="order-number">${t.orderNumber} ${data.orderNumber}</div>
                        <div class="order-date">${t.placedOn} ${translateDateToFrench(data.orderDate)}</div>
                    </div>
                    <div class="order-actions">
                        <div class="order-status-badge ${statusClass}">${translatedStatus}</div>
                        ${trackingButtonHTML}
                    </div>
                </div>

                ${deliveryPredictionHTML}

                <div class="order-details">
                    <div class="order-detail">
                        <div class="order-detail-label">${t.paymentStatus}</div>
                        <div class="order-detail-value">${translatedFinancialStatus}</div>
                    </div>
                    <div class="order-detail">
                        <div class="order-detail-label">${t.carrier}</div>
                        <div class="order-detail-value">${data.carrier || 'La Poste'}</div>
                    </div>
                    ${shippingHTML}
                    <div class="order-detail">
                        <div class="order-detail-label">${t.contactEmail}</div>
                        <div class="order-detail-value">${data.email}</div>
                    </div>
                </div>

                <div class="order-items">
                    <h4>${t.orderItems} (${data.itemCount})</h4>
                    ${itemsHTML}
                    <div class="order-totals-breakdown">
                        <div class="breakdown-row">
                            <span class="breakdown-label">${t.subtotal || 'Sous-total'}</span>
                            <span class="breakdown-value">${currencySymbol}${parseFloat(data.subtotalPrice || data.totalPrice).toFixed(2)}</span>
                        </div>
                        <div class="breakdown-row">
                            <span class="breakdown-label">${t.shipping || 'Frais de livraison'}</span>
                            <span class="breakdown-value">${currencySymbol}${parseFloat(data.totalShippingPrice || '0.00').toFixed(2)}</span>
                        </div>
                        ${parseFloat(data.totalDiscounts || 0) > 0 ? `
                        <div class="breakdown-row discount-row">
                            <span class="breakdown-label">${t.discount || 'Remise'}</span>
                            <span class="breakdown-value">-${currencySymbol}${parseFloat(data.totalDiscounts).toFixed(2)}</span>
                        </div>
                        ` : ''}
                        ${(data.taxLines && data.taxLines.length > 0) ? data.taxLines.map(line => `
                        <div class="breakdown-row">
                            <span class="breakdown-label">${line.title}${line.ratePercentage ? ` (${line.ratePercentage}%)` : ''}${data.taxesIncluded ? ' (inclus)' : ''}</span>
                            <span class="breakdown-value">${currencySymbol}${parseFloat(line.price).toFixed(2)}</span>
                        </div>
                        `).join('') : `
                        <div class="breakdown-row">
                            <span class="breakdown-label">${t.tax || 'TVA'}${data.taxesIncluded ? ' (inclus)' : ''}</span>
                            <span class="breakdown-value">${currencySymbol}${parseFloat(data.totalTax || '0.00').toFixed(2)}</span>
                        </div>
                        `}
                        <div class="breakdown-row grand-total-row">
                            <span class="breakdown-label">${t.grandTotal || 'Total à payer'}</span>
                            <span class="breakdown-value order-total-value">${currencySymbol}${parseFloat(data.totalPrice).toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                ${isFROrder ? `
                <div class="invoice-download-section" style="margin-top: 2rem; padding-top: 2rem; border-top: 2px solid var(--border-color); text-align: center;">
                    <button onclick="downloadInvoice('${data.orderNumber}', '${data.orderDate}', '${locale}')" class="invoice-download-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                        <span>${t.downloadInvoice || 'Télécharger la facture'}</span>
                    </button>
                </div>
                ` : ''}
            </div>
        `;

        resultsDiv.style.display = 'block';
        resultsDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        lookupBtn.disabled = false;
        lookupBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
            </svg>
            ${t.findMyOrder}
        `;

    } catch (error) {
        console.error('Order lookup error:', error);
        const t = translations['fr-FR'];

        resultsDiv.innerHTML = `
            <div class="order-error">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <p>${t.connectionError}</p>
            </div>
        `;
        resultsDiv.style.display = 'block';

        lookupBtn.disabled = false;
        lookupBtn.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
            </svg>
            ${t.findMyOrder}
        `;
    }
};
})();
// ============================================================================
// URL PARAMETER PRE-FILL - Auto-fill order lookup from marketing links
// Supports: ?orderNumber=12341324&orderEmail=bart@bookerz.nl#orders
// ============================================================================
(function() {
    'use strict';

    function prefillFromUrlParams() {
        var params = new URLSearchParams(window.location.search);
        var orderNumber = params.get('orderNumber');
        var orderEmail = params.get('orderEmail');

        if (!orderNumber || !orderEmail) return;

        var numberInput = document.getElementById('orderNumber');
        var emailInput = document.getElementById('orderEmail');

        if (!numberInput || !emailInput) return;

        numberInput.value = orderNumber;
        emailInput.value = orderEmail;

        // Navigate to the orders section
        if (typeof window.showSection === 'function') {
            window.showSection('orders');
        }

        // Trigger the order lookup automatically
        setTimeout(function() {
            if (typeof window.lookupOrder === 'function') {
                window.lookupOrder();
            }
        }, 400);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', prefillFromUrlParams);
    } else {
        prefillFromUrlParams();
    }
})();
// ============================================================================
// FAQ NAVIGATION - Bulletproof deep links to FAQ items
// Supports: #section.faq-item-id (e.g., #orders.faq-orders-track)
// Also supports: #section#faq-item-id and #faq-item-id
// ============================================================================
(function() {
    'use strict';

    function parseHash(hash) {
        if (!hash) return null;
        var dotIdx = hash.indexOf('.');
        if (dotIdx > 0) {
            return { section: hash.substring(0, dotIdx), faqId: hash.substring(dotIdx + 1) };
        }
        var hashIdx = hash.indexOf('#');
        if (hashIdx > 0) {
            return { section: hash.substring(0, hashIdx), faqId: hash.substring(hashIdx + 1) };
        }
        if (hash.startsWith('faq-')) {
            return { section: null, faqId: hash };
        }
        return { section: hash, faqId: null };
    }

    function forceShowSection(sectionId) {
        document.querySelectorAll('.cs-nav-item, .cs-mobile-menu-item').forEach(function(item) {
            item.classList.remove('active');
            if (item.dataset.section === sectionId) {
                item.classList.add('active');
            }
        });
        document.querySelectorAll('.cs-section').forEach(function(section) {
            if (section.id === sectionId) {
                section.classList.remove('page-hidden');
                section.classList.add('page-active');
            } else {
                section.classList.remove('page-active');
                section.classList.add('page-hidden');
            }
        });
    }

    function activateSection(sectionId) {
        if (typeof window.showSection === 'function') {
            window.showSection(sectionId);
        } else {
            forceShowSection(sectionId);
        }
    }

    function scrollToAndOpenFAQ(faqId, retries) {
        retries = retries || 0;
        var faqItem = document.getElementById(faqId);
        if (!faqItem) {
            if (retries < 15) {
                setTimeout(function() { scrollToAndOpenFAQ(faqId, retries + 1); }, 200);
            }
            return;
        }
        document.querySelectorAll('.faq-item.active').forEach(function(item) {
            item.classList.remove('active');
        });
        faqItem.classList.add('active');
        requestAnimationFrame(function() {
            setTimeout(function() {
                faqItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 450); // Increased to 450ms to wait for the accordion's CSS transition
        });
    }

    function handleFAQNavigation(hash) {
        if (!hash) return false;
        var parsed = parseHash(hash);
        if (!parsed) return false;
        if (parsed.section && parsed.faqId) {
            activateSection(parsed.section);
            setTimeout(function() { scrollToAndOpenFAQ(parsed.faqId, 0); }, 300);
            return true;
        }
        if (!parsed.section && parsed.faqId) {
            var faqItem = document.getElementById(parsed.faqId);
            if (faqItem) {
                var parentSection = faqItem.closest('.cs-section');
                if (parentSection) {
                    activateSection(parentSection.id);
                    setTimeout(function() { scrollToAndOpenFAQ(parsed.faqId, 0); }, 300);
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    function init() {
        var hash = window.location.hash.substring(1);
        if (!hash) return;
        if (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-')) {
            handleFAQNavigation(hash);
            setTimeout(function() { handleFAQNavigation(hash); }, 800);
            setTimeout(function() { handleFAQNavigation(hash); }, 2000);
        }
    }

    window.addEventListener('hashchange', function() {
        var hash = window.location.hash.substring(1);
        if (hash && (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-'))) {
            handleFAQNavigation(hash);
        }
    });

    document.addEventListener('click', function(e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        var hash = '';
        if (href.startsWith('#')) {
            hash = href.substring(1);
        } else if (href.includes('#')) {
            try {
                var linkUrl = new URL(href, window.location.origin);
                hash = linkUrl.hash ? linkUrl.hash.substring(1) : '';
            } catch (err) { return; }
        }
        if (hash && (hash.includes('.') || hash.indexOf('#') > 0 || hash.startsWith('faq-'))) {
            e.preventDefault();
            e.stopPropagation();
            window.history.pushState({}, '', '#' + hash);
            handleFAQNavigation(hash);
        }
    }, true);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();